/*

  Implementated by Amit Sharma
  Dated : 12/3/2019

*/

import React, { Component } from "react";
import { Row, ModalBody} from 'reactstrap';

class EmployerEnterpriseCustomSuccess extends Component {

    render() {
        const thumbsUpIcon = <i className="fal fa-thumbs-up fa-8x"/>;
            
        return (
            <>
                {/* <Progress value="30" color="warning" /> */}
                <ModalBody>
                    <div className="text-center my-4">
                        <h5 style={{ fontSize: '38px' }}>You’re all set</h5>
                    </div>
                    <Row>
                    <button type="button" className="btn btn-block"
                        data-toggle="tooltip" title="All Set!">{thumbsUpIcon}</button>
                    </Row>
                    <div className="text-center my-4">
                        <div className="form-group fontSize1point2rem">
                            An account representative will contact you within the next 24-48 hours.
                        </div>
                    </div>
                </ModalBody>
            </>
        )
    }

}

export default EmployerEnterpriseCustomSuccess;